import WindowDefaults from './types/WindowDefaults';
import { EnvDiagnostics } from './types/EnvDiagnostics';
import { calculateBootType } from './calculateBootType';

// This is only called in the index.html case
let diagnostics: EnvDiagnostics = {};
export function updateDiagnosticsOnReponse(response: Response) {
    updateField('fe', response, 'X-FEServer');
    updateField('be', response, 'X-BEServer');
    updateField('cbc', response, 'X-CalculatedBETarget');
    updateField('wsver', response, 'X-OWA-Version');
    updateField('fost', response, 'x-owa-forest');
    updateField('dag', response, 'x-owa-dag');

    if (!diagnostics.te && response && response.headers) {
        diagnostics.te = response.headers.get('X-MSEdge-Ref') ? '1' : '0';
    }
}

let startTime: number;
export function setStartTime(time: number) {
    startTime = time;
}
export function getStartTime() {
    return startTime;
}

function updateField(key: string, response: Response, header: string) {
    if (!diagnostics[key] && response && response.headers) {
        diagnostics[key] = response.headers.get(header);
    }
}

// This functions need to work for both boot scenarios
// 1. The entry point which includes owa-start and owa.MailBoot.js
//       In this case the diagnostics object is populated from the function above
// 2. The entry point that contains preboot and owa.mail.js.
//     This scenario populates genericDiagnostics in preboot so we need to keep this for
//     backwards compatibility (Eventually this will be deleted as we just use the first scenario)
function getValue(key: string) {
    const currentDiagnostics = diagnostics || (<WindowDefaults>(<any>window)).genericDiagnostics;
    return currentDiagnostics && currentDiagnostics[key];
}

export function getBackend() {
    return getValue('be');
}

export function getFrontend() {
    return getValue('fe');
}

export function getThroughEdge() {
    return getValue('te');
}

export function getServerVersion() {
    return getValue('wsver');
}

export function getDag() {
    return getValue('dag');
}

export function getForest() {
    return getValue('fost');
}

export function getCalculatedBe() {
    return getValue('cbe');
}
export async function getBootType() {
    let bootType = getValue('bt');
    if (!bootType) {
        diagnostics.bt = await calculateBootType(
            window.performance && window.performance.timing
                ? window.performance.timing.fetchStart
                : startTime
        );
    }
    return bootType;
}
